module.exports = __webpack_public_path__ + "img/framenew_box08.6d6756ab.jpg";